module.exports = __webpack_public_path__ + "img/icon_lvjing_shaonv_normal@2x.df5be178.png";